import React, { useState } from 'react';
import Slider from 'react-rangeslider';
import './styles.scss';

const CommissionSlider = ({
  initialValue,
  isCalculating,
  max,
  step,
  handleChange,
  type,
}) => {
  const [rate, setRate] = useState(initialValue || 0);

  const format = (value) => {
    return value + '%';
  };
  const onChangeComplete = () => {
    handleChange(rate, type);
  };
  const onChange = (value) => {
    setRate(value);
  };

  return (
    <div>
      <Slider
        value={rate || 0}
        disabled={isCalculating}
        max={max}
        step={step}
        format={format}
        onChange={onChange}
        onChangeComplete={onChangeComplete}
      />
    </div>
  );
};
export default CommissionSlider;
